import { useRef } from 'react'
import { FieldWrapper, TitleInfo, TwoOptionSwitch} from '~/components'
import * as styles from './index.module.css'

export default function IconSwitch({ field, form, title, info, icon1, icon2, noPadding, reverseLayout, alternateBackground, larger, children, innerRef, ...props }) {
  const isChecked = Array.isArray(field.value) ? field.value.includes(props?.value) : field.value
  const isDisabled = props.disabled
  const clickRef = useRef()

  const wrapperClick = e => {
    if (e.clientX !== 0 && e.clientY !== 0) {
      (innerRef || clickRef)?.current?.click()
    }
  }

  return (
    <FieldWrapper reverseLayout={reverseLayout} noPadding alternateBackground={alternateBackground} isDisabled={isDisabled} larger={larger} onClick={wrapperClick}>
      <div className={styles.content}>
        <TitleInfo title={title} info={info} />
        {children}
      </div>
      <TwoOptionSwitch 
        innerRef={innerRef || clickRef}
        isChecked={isChecked}
        icon1={icon1}
        icon2={icon2}
        name={field.name} 
        field={field}
        form={form}
        onChange={field.onChange} 
        onBlur={field.onBlur} 
        {...props} 
      />
    </FieldWrapper>
  )
}
